const __WEBPACK_NAMESPACE_OBJECT__ = window["core-js/modules/es.number.is-nan.js"];